import React, { useState } from "react";
import DialogPopup from "@_components/DialogPopup/DialogPopup";
import Button from "@mui/material/Button";
import styles from "./AddCaseTagPopup.module.css";
import { useEffect } from "react";
import { Autocomplete } from "@mui/material";
import { TextField } from "@mui/material";
import AppSnackbar from "@_components/AppSnackbar/AppSnackbar";
import { useSnackbar } from "@_hooks/useSnackbar";
import { useDispatch, useSelector } from "react-redux";
import { caseActions } from "@_actions/case.actions";
import { customerActions } from "@_actions/customer.actions";
import { catchError } from "@_utils/helpers";

function AddCaseTagPopup(props) {
  const dispatch = useDispatch();
  const customerReducer = useSelector((state) => state.customerReducer);
  const caseReducer = useSelector((state) => state.caseReducer);
  const caseData = props.caseData;
  const tags = props.tags;
  const [newTag, setNewTag] = useState("");
  const { snackbarProps, showSnackbarError } = useSnackbar();

  useEffect(() => {
    dispatch(customerActions.getCaseTags());
  }, [dispatch]);

  useEffect(() => {
    if (caseReducer.status.CASE_ADD_TAG === "success") {
      dispatch(caseActions.clearStateMessage("CASE_ADD_TAG"));
      dispatch(
        caseActions.getCaseWithChargeDetails(caseData.id, caseData.overview),
      );
      dispatch(customerActions.getCaseTags());
      onClose();
    } else if (catchError(caseReducer.status.CASE_ADD_TAG)) {
      showSnackbarError(caseReducer.status.CASE_ADD_TAG);
      dispatch(caseActions.clearStateMessage("CASE_ADD_TAG"));
    }
    // eslint-disable-next-line
  }, [
    caseReducer.status.CASE_ADD_TAG,
    dispatch,
    caseData.id,
    caseData.overview,
  ]);

  const onClose = () => {
    setNewTag("");
    props.close();
  };

  let filteredTags = customerReducer.case_tags.filter(
    (tag) => !tags?.includes(tag),
  );

  const handleSetNewTag = (event, newTagInput) => {
    if (
      !event ||
      (event.nativeEvent?.type === "input" &&
        /^[a-zA-Z0-9_\-!+= ]*$/.test(newTagInput))
    )
      setNewTag(newTagInput);
  };

  const addNewTag = () => {
    if (!newTag) {
      showSnackbarError("Please add a tag name");
    } else dispatch(caseActions.addCaseTag(caseData.id, newTag));
  };

  return (
    <>
      <DialogPopup open={props.open} onClose={() => props.close()}>
        <div className={styles.add_tag_container}>
          <div className={styles.autocomplete_container}>
            <Autocomplete
              freeSolo
              disableClearable
              inputValue={newTag}
              onInputChange={handleSetNewTag}
              options={filteredTags || []}
              sx={{ width: 300 }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Search input"
                  InputProps={{
                    ...params.InputProps,
                    type: "search",
                  }}
                />
              )}
            />
          </div>
          <Button className="btn_confirm" onClick={addNewTag}>
            {filteredTags?.some((tag) => tag === newTag)
              ? "Add Case Tag"
              : "Create Case Tag"}
          </Button>
        </div>
      </DialogPopup>
      <AppSnackbar {...snackbarProps} />
    </>
  );
}

export default AddCaseTagPopup;
